/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { CoreStrictHttpResponse } from '../../core-strict-http-response';
import { CoreRequestBuilder } from '../../core-request-builder';

import { CoreProjectSubtaskResponseDto } from '../../models/core-project-subtask-response-dto';

export interface ProjectSubtasksControllerFindByTaskId$Params {

/**
 * The tenant identifier.
 */
  tenant: string;

/**
 * The task ID to filter subtasks by.
 */
  taskId: string;
}

export function projectSubtasksControllerFindByTaskId(http: HttpClient, rootUrl: string, params: ProjectSubtasksControllerFindByTaskId$Params, context?: HttpContext): Observable<CoreStrictHttpResponse<Array<CoreProjectSubtaskResponseDto>>> {
  const rb = new CoreRequestBuilder(rootUrl, projectSubtasksControllerFindByTaskId.PATH, 'get');
  if (params) {
    rb.path('tenant', params.tenant, {});
    rb.path('taskId', params.taskId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as CoreStrictHttpResponse<Array<CoreProjectSubtaskResponseDto>>;
    })
  );
}

projectSubtasksControllerFindByTaskId.PATH = '/o2-core/project-subtasks/{tenant}/task/{taskId}/subtasks';
